import { Component } from '@wordpress/element';
import ChartBuilder from './ChartBuilder';
import { DataProvider } from '../Utilities/DataContext';
import { ErrorBoundary } from '../Utilities';
// import { LazyLoadModule, Title } from "./Utilities";
// import "./App.css";

class ChartBuilderWrapper extends Component {
    state = {
        data: this.props.data,
        config: this.props.config,
    };

    render() {
        return (
            <ErrorBoundary>
                <DataProvider
                    value={{
                        data: this.state.data,
                        config: this.state.config,
                    }}
                >
                    <ErrorBoundary>
                        <ChartBuilder />
                    </ErrorBoundary>
                </DataProvider>
            </ErrorBoundary>
        );
    }
}

export default ChartBuilderWrapper;
